const styles = {
  row: {
    textAlign: 'center'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/BookShelf.js